<template lang="pug">
  .photo-reports(v-if="content")
    .page__wr
      PageConstruction(v-if="content.pageConstruction")
      template(v-else)
        Bread(v-if="content.bread", :bread="content.bread")
        .photo-reports__title(v-if="h1") {{h1}}
        .photo-reports__items-wr
          PreloaderImage
          .photo-reports__items(v-if="content.items")
            router-link.photo-reports__item(v-for="item in content.items", :key="item.id", :to="item.link")
              .photo-reports__item-img-wr
                img.photo-reports__item-img(v-if="item.img", :src="item.img")
                .photo-reports__item-img-overlay
                  SvgIcon.photo-reports__item-img-overlay-ico(name="search", width="34", height="34")
              .photo-reports__item-date(v-if="item.date") {{item.date}}
              .photo-reports__item-title(v-if="item.title") {{item.title}}
        Pagination(v-if="content.pageCount && content.pageCount > 1", :activePage="page", :pageCount="content.pageCount")
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/photoReports/photoReports.styl';

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import Bread from '@/components/common/bread/bread.vue';
  import PreloaderImage from '@/components/common/preloaderImage/preloaderImage.vue';
  import Pagination from '@/components/common/pagination/pagination.vue';
  import PageConstruction from '@/components/common/pageConstruction/pageConstruction.vue';

  export default {
    name: 'PhotoReports',

    mixins: [AjaxHelpersVue],

    data() {
      return {
        content: null,
        page: 1
      }
    },

    components: {
      SvgIcon,
      Bread,
      PreloaderImage,
      Pagination,
      PageConstruction
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadPhotoReportsPage', params => {
        this.request(params.url);
      });

      EventBus.$on('setPagination', params => {
        if(params.blockId == 'photo-reports') {
          this.page = params.page;
          this.requestInside();
        }
      });
    },

    methods: {
      request(url) {
        let searchParams = new URLSearchParams(window.location.search.substring(1));

        if(searchParams.get("page") == null) {
          this.page = 1;
        } else {
          this.page = +searchParams.get("page");
        }

        let params = {
          url: url,
          page: this.page
        };

        this.req('PhotoReportsPage:getPhotoReportsPage', {...params}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;

            this.$nextTick(() => {

            });
          }
        }, 'photo-reports');
      },

      requestInside() {
        EventBus.$emit('preloaderShow', 'photo-reports');

        let params = {
          page: this.page
        };

        this.req('PhotoReportsPage:getPhotoReportsItems', {...params}, res => {
          if(this.checkProperty(res.content)) {
            this.content.items = res.content.items;

            this.$nextTick(() => {
              EventBus.$emit('preloaderHide', 'photo-reports');
            });
          }
        }, '', 'localPageRequest');
      },
    }

  }
</script>
